require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// C:/Temp/instagraph-web-client/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 700
// module chunks = 0